<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      ref="controllerList"
    :headers="(hasDir)?header_dir:header_unDir"
    :get-data-func="(hasDir)?getDirControllerList:getUnDirControllerList"
      @click:row="getDetails($event.item)"
      clickable>
      <template slot="title">
        <span class="pl-2 pr-4">卡口列表</span>
        <v-radio-group mandatory row v-model="hasDir">
          <v-radio :value="true" label="有方向"></v-radio>
          <v-radio :value="false" label="无方向"></v-radio>
        </v-radio-group>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-tooltip left>
            <v-btn @click="(hasDir)?deleteDirControllerConfirm(item):deleteUnDirControllerConfirm(item)" slot="activator" icon>
              <v-icon small>$vuetify.icons.delete</v-icon>
            </v-btn>
            <span>删除卡口</span>
          </v-tooltip>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn
      @click="addController"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
import {time} from '../../ladmin/utils/time'
let gateTypeMap = {
  '0': '通行卡口',
  '1': '计费卡口',
  '2': '支付卡口',
  '3': '边界卡口'
}
function gateTypeTrans (v) {
  if (v === '') {
    return "N/A"
  }
  if (v === null) {
    return 'N/A'
  }
  if (v === "null") {
    return 'N/A'
  }
  let obj = eval(v)
  let ans = '【'
  for (let p in obj) {
    ans += gateTypeMap[obj[p]]
    ans += '，'
  }
  ans = ans.substr(0, ans.length - 1)
  ans += '】'
  return ans
}
export default {
  name: 'controllerList',
  components: {LDataTable},
  data () {
    return {
      hasDir: false,
      header_dir: [
        {text: '卡口名称', value: 'name', align: 'left', sortable: false},
        {text: '卡口类型', value: 'gateType', align: 'left', sortable: false, f: (v) => gateTypeTrans(v), placeholder: 'N/A'},
        {text: '创建时间', value: 'creationTime', align: 'left', f: (v) => (time.stringify(v))},
        {text: '', value: '', align: 'left', sortable: false}
      ],
      header_unDir: [
        {text: '卡口名称', value: 'name', align: 'left', sortable: false},
        {text: '创建时间', value: 'creationTime', align: 'left', f: (v) => (time.stringify(v))},
        {text: '', value: '', align: 'left', sortable: false}
      ]
    }
  },
  methods: {
    async getDirControllerList ({pagination, sortStack, filterItems, search}) {
      let res = await this.$store.dispatch('park/getDirControllerList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}})
      return res
    },
    async getUnDirControllerList ({pagination, sortStack, filterItems, search}) {
      let res = await this.$store.dispatch('park/getUnDirControllerList', {pagination, sortStack, filterItems, search: {key: 'name', value: search}})
      return res
    },
    addController () {
      this.$router.push({name: 'newController'})
    },
    async deleteDirControllerConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该卡口？',
        text: '卡口名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteDirController(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteDirController (item) {
      let ids = []
      ids.push(item.id)
      let res = await this.$store.dispatch('park/deleteDirController', ids)
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.controllerList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
    async deleteUnDirControllerConfirm (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除该卡口？',
        text: '卡口名称:' + item.name
      })
      if (res) {
        try {
          await this.deleteUnDirController(item)
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async deleteUnDirController (item) {
      let ids = []
      ids.push(item.id)
      let res = await this.$store.dispatch('park/deleteUnDirController', ids)
      if (res.data.status + '' === '200') {
        this.$L.alert('success', {message: '删除成功'})
        this.$refs.controllerList.refresh()
      }
      else {
        this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
      }
    },
    getDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({name: 'controllerDetailsBox', query: {id: item.id, name:item.name,type: (this.hasDir) ? 'dir' : 'unDir'}})
      }
    },
  },
  activated () {
    this.$refs.controllerList.refresh()
  }
}
</script>

<style scoped>

</style>
